export default "__VITE_ASSET__CYgkLvhx__"